<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>Testing</h2>
      <p class="description">Descargas de prueba para endpoints internos</p>
    </div>

    <div class="segments-panel">
      <div class="panel-header">
        <h3>Listas de mails CRM</h3>
        <button type="button" class="btn-secondary" :disabled="loadingSegments" @click="loadSegments">
          {{ loadingSegments ? 'Cargando...' : 'Recargar' }}
        </button>
      </div>

      <div v-if="segments.length" class="segments-grid">
        <div v-for="segment in segments" :key="segment.id" class="segment-row">
          <div class="segment-info">
            <strong>{{ segment.label }}</strong>
            <span>{{ segment.description }}</span>
          </div>
          <button
            type="button"
            class="btn-primary"
            :disabled="downloadingSegment === segment.id"
            @click="downloadSegment(segment)"
          >
            {{ downloadingSegment === segment.id ? 'Generando...' : 'Descargar CSV' }}
          </button>
        </div>
      </div>

      <div v-else class="empty-state">
        {{ loadingSegments ? 'Cargando segmentos...' : 'No hay segmentos disponibles.' }}
      </div>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TestingTab',
  data() {
    return {
      segments: [],
      loadingSegments: false,
      downloadingSegment: '',
      message: '',
      messageType: '',
    };
  },
  mounted() {
    this.loadSegments();
  },
  methods: {
    async loadSegments() {
      this.loadingSegments = true;
      this.message = '';

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/testing/mail-segments`);
        if (response.data.success) {
          this.segments = response.data.segments || [];
        }
        else {
          this.showMessage(response.data.message || 'No se pudieron cargar los segmentos.', 'error');
        }
      }
      catch (error) {
        this.showMessage('No se pudieron cargar los segmentos.', 'error');
      }
      finally {
        this.loadingSegments = false;
      }
    },
    async downloadSegment(segment) {
      this.downloadingSegment = segment.id;
      this.message = '';

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/adminmenu/testing/mail-segments/${segment.id}/csv`,
          { responseType: 'blob' }
        );
        const contentType = response.headers['content-type'] || '';
        if (contentType.indexOf('application/json') !== -1) {
          await this.showBlobError(response.data);
          return;
        }

        const filename = this.filenameFromDisposition(response.headers['content-disposition'])
          || `testing-mails-${segment.id}.csv`;
        this.saveBlob(response.data, filename);
        this.showMessage(`CSV de ${segment.label} descargado.`, 'success');
      }
      catch (error) {
        if (error.response && error.response.data) {
          await this.showBlobError(error.response.data);
        }
        else {
          this.showMessage('No se pudo descargar el CSV.', 'error');
        }
      }
      finally {
        this.downloadingSegment = '';
      }
    },
    saveBlob(data, filename) {
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    filenameFromDisposition(disposition) {
      if (!disposition) {
        return '';
      }
      const match = disposition.match(/filename="?([^"]+)"?/);
      return match ? match[1] : '';
    },
    async showBlobError(blob) {
      try {
        const text = await blob.text();
        const data = JSON.parse(text);
        this.showMessage(data.message || 'No se pudo descargar el CSV.', 'error');
      }
      catch (error) {
        this.showMessage('No se pudo descargar el CSV.', 'error');
      }
    },
    showMessage(message, type) {
      this.message = message;
      this.messageType = type;

      if (type === 'success') {
        setTimeout(() => {
          this.message = '';
        }, 5000);
      }
    },
  },
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.segments-panel {
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  padding: 20px;
}

.panel-header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 18px;
}

.panel-header h3 {
  color: #e6e6e6;
  font-size: 18px;
  margin: 0;
}

.segments-grid {
  display: grid;
  gap: 12px;
}

.segment-row {
  align-items: center;
  background: #222;
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  min-height: 76px;
  padding: 14px 16px;
}

.segment-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.segment-info strong {
  color: #fff;
  font-size: 15px;
}

.segment-info span {
  color: #aaa;
  font-size: 13px;
  line-height: 1.4;
}

.btn-primary,
.btn-secondary {
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 14px;
  min-width: 132px;
  padding: 10px 18px;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #3498db;
}

.btn-secondary {
  background: #555;
  min-width: 96px;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-secondary:hover:not(:disabled) {
  background: #666;
}

.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.empty-state {
  background: #222;
  border: 1px dashed #444;
  border-radius: 6px;
  color: #aaa;
  padding: 18px;
}

.message-box {
  background-color: #333;
  border-left: 3px solid #3498db;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}

@media (max-width: 720px) {
  .panel-header,
  .segment-row {
    align-items: stretch;
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}
</style>
